//羽毛球 汤尤杯 full
import PlatfromBadmintonCupFullThomasAndUber from '@containers/platfrom_badminton/badmintonCupFull_thomasAndUber.vue'

export default {
  PlatfromBadmintonCupFullThomasAndUber,
}
